var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.shortLink == 'kardiyolojinobelleri' ||
    _vm.shortLink == '25aralikkardiyolojigundemi' ||
    _vm.shortLink == 'diyabet360'
  )?_c('EcongressLive'):_c('Live')}
var staticRenderFns = []

export { render, staticRenderFns }